<div class="info scrollbar-deep-purple bordered-deep-purple thin">
  <spinner [id]="'infobox'" [show]='activeSpinner'></spinner>

 
  <div class="p-2">
    <div class="card statistic-data">
      <div class="bread_crumb">{{'infotab.area' | translate}}</div>
      <!-- <button class="" _ngcontent-c1="" (click)="showDataTab=!showDataTab;revalidateMap()"
      [class]="!showDataTab? 'as-split-area d-none as-hidden info_close': 'info_close'">
      <i _ngcontent-c1="" class="fas fa-times-circle"></i>
    </button> -->
    </div>
    <div class="card statistic-data mb-0">
      <app-breadcrumb (label)="changeRegion($event)"></app-breadcrumb>
    </div>
    <div class="card statistic-data">
      <p class="card-title">{{'infotab.datatitle' | translate}} {{year}}</p>
    </div>
  </div>
  <div class="p-2">
    <div class="card statistic-data">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-sm table-striped m-0">
            <thead>
              <tr>
                <th colspan="4" class="text-center">{{'infotab.bihar' | translate}}</th>
              </tr>
              <tr>
                <th>{{'infotab.district' | translate}}</th>
                <th>{{'infotab.rank' | translate}}</th>
                <th> {{'infotab.scores' | translate}}</th>
                <th>{{'infotab.areas' | translate}}</th>
              </tr>
            </thead>
            <tbody *ngIf="tabledataforBihar.length >0">
              <tr *ngFor="let tabledata of tabledataforBihar;let i=index;">
                <td>{{ 'districtsdata.' + tabledata.name | translate}}</td>
                <td>{{ tabledata.rank}}</td>
                <td>{{validatefixedValue(tabledata.score)}}</td>
                <td>{{tabledata.improvement}}</td>
            </tbody>
            <tbody *ngIf="tabledataforBihar.length == 0">
              <tr style="text-align: center;font-size: 13px;">{{'infotab.nodata' | translate}}</tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card statistic-data">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th colspan="4" class="text-center">{{'infotab.jkdist' | translate}}</th>
              </tr>
              <tr>
                <th>{{'infotab.district' | translate}}</th>
                <th>{{'infotab.rank' | translate}}</th>
                <th> {{'infotab.scores' | translate}}</th>
                <th>{{'infotab.areas' | translate}}</th>
              </tr>
            </thead>
            <tbody *ngIf="tabledataforJK.length > 0">
              <tr *ngFor="let tabledata of tabledataforJK;let i=index;">
                <td>{{ 'districtsdata.' + tabledata.name | translate}}</td>
                <td>{{tabledata.rank}}</td>
                <td>{{validatefixedValue(tabledata.score)}}</td>
                <td>{{tabledata.improvement}}</td>
              </tr>
            </tbody>
            <tbody *ngIf="tabledataforJK.length == 0">
              <tr style="text-align: center;font-size: 13px;">{{'infotab.nodata' | translate}}</tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card statistic-data">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table">
            <thead class="font-weight-bold">
              <tr>
                <th colspan="4" class="text-center">{{'infotab.updist' | translate}}</th>
              </tr>
              <tr>
                <th>{{'infotab.district' | translate}}</th>
                <th>{{'infotab.rank' | translate}}</th>
                <th> {{'infotab.scores' | translate}}</th>
                <th>{{'infotab.areas' | translate}}</th>
              </tr>
            </thead>
            <tbody *ngIf="tabledataforUP.length > 0">
              <tr *ngFor="let tabledata of tabledataforUP;let i=index;">
                <td>{{ 'districtsdata.' + tabledata.name | translate}}</td>
                <td>{{tabledata.rank}}</td>
                <td>{{validatefixedValue(tabledata.score)}}</td>
                <td>{{tabledata.improvement}}</td>
              </tr>
            </tbody>
            <tbody *ngIf="tabledataforUP.length == 0">
              <tr style="text-align: center;font-size: 13px;">{{'infotab.nodata' | translate}}</tr>
            </tbody>
          </table>
          <!-- </table>   -->
        </div>
      </div>
    </div>
    <div class="card statistic-data">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table">
            <thead class="font-weight-bold">
              <tr>
                <th colspan="4" class="text-center">{{'infotab.ukdist' | translate}}</th>
              </tr>
              <tr>
                <th>{{'infotab.district' | translate}}</th>
                <th>{{'infotab.rank' | translate}}</th>
                <th> {{'infotab.scores' | translate}}</th>
                <th>{{'infotab.areas' | translate}}</th>
              </tr>
            </thead>
            <tbody *ngIf="tabledataforUK.length > 0">
              <tr *ngFor="let tabledata of tabledataforUK;let i=index;">
                <td>{{ 'districtsdata.' + tabledata.name | translate}}</td>
                <td>{{tabledata.rank}}</td>
                <td>{{validatefixedValue(tabledata.score)}}</td>
                <td>{{tabledata.improvement}}</td>
              </tr>
            </tbody>
            <tbody *ngIf="tabledataforUK.length == 0">
              <tr style="text-align: center;font-size: 13px;">{{'infotab.nodata' | translate}}</tr>
            </tbody>
          </table>
          <!-- </table>   -->
        </div>
      </div>
    </div>
    <div class="card statistic-data">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table">
            <thead class="font-weight-bold">
              <tr>
                <th colspan="4" class="text-center">{{'infotab.wbdist' | translate}}</th>
              </tr>
              <tr>
                <th>{{'infotab.district' | translate}}</th>
                <th>{{'infotab.rank' | translate}}</th>
                <th> {{'infotab.scores' | translate}}</th>
                <th>{{'infotab.areas' | translate}}</th>
              </tr>
            </thead>
            <tbody *ngIf="tabledataforWB.length > 0">
              <tr *ngFor="let tabledata of tabledataforWB;let i=index;">
                <td>{{ 'districtsdata.' + tabledata.name | translate}}</td>
                <td>{{tabledata.rank}}</td>
                <td>{{validatefixedValue(tabledata.score)}}</td>
                <td>{{tabledata.improvement}}</td>
              </tr>
            </tbody>
            <tbody *ngIf="tabledataforWB.length == 0">
              <tr style="text-align: center;font-size: 13px;">{{'infotab.nodata' | translate}}</tr>
            </tbody>
          </table>
          <!-- </table>   -->
        </div>
      </div>
    </div>
  </div>

  <div class="card statistic-data" *ngIf="!hidestatereports">
    <div class="card-body px-2">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" style="width:58px;background-color: #193863;text-align: center;">S No</th>
              <th scope="col" style="text-align:center;background-color: #193863;text-align: center;">Indicator</th>
              <th scope="col" style="width:58px;background-color: #193863;text-align: center;">Rank</th>
              <th scope="col" style="width:100px;background-color: #193863;text-align: center;">CWI Scores</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of tabledataindicators">
              <td>{{row['sno']}}</td>
              <td>{{row['name']}}</td>
              <td>{{ row['rank']}}</td>
              <td>{{checkscorevalue(row['score'])}}</td>
            </tr>
          </tbody>
          <tbody *ngIf="tabledataindicators.length == 0">
            <tr style="text-align: center;font-size: 13px;">{{ 'infotab.nodata' | translate }}</tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>